/**
 * @param {string | null | undefined} string
 * @return {boolean}
 */
export default function isEmptyString(string: string | null | undefined): boolean {
  return !string || string.length === 0 || !string.trim();
}
